var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6ef7aff4-5c9b-4e97-acf8-68565a47d66d",
    gradientUnits: "userSpaceOnUse",
    x1: -0.202,
    x2: 21.123,
    y1: 28,
    y2: 6.202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fee72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#fed51b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#fdca10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#fdc70c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#f3903f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ed683c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e93e3a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.7 11.717a6 6 0 1 0 -7.392 0 10.008 10.008 0 0 0 -6.308 9.283v1a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-1a10.008 10.008 0 0 0 -6.3-9.283zm-7.7-4.717a4 4 0 1 1 4 4 4 4 0 0 1 -4-4zm-4 14a8 8 0 0 1 16 0z",
    fill: "url(#6ef7aff4-5c9b-4e97-acf8-68565a47d66d)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDark);
export default __webpack_public_path__ + "static/media/AccountDark.3df9a692.svg";
export { ForwardRef as ReactComponent };